export const NODE_NAME_FIRST_NAME = 'first-name';
export const NODE_NAME_LAST_NAME = 'last-name';
export const NODE_NAME_EMAIL = 'email';
export const NODE_NAME_GUEST_INFORMATION = 'guest-information';
export const NODE_NAME_SALE_INFORMATION = 'sale-information';
export const NODE_NAME_ATTENDING = 'attending';
export const NODE_NAME_ADDITIONAL_GUEST_COUNT = 'additional-guest-count';
export const NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP = 'additional-guest';
export const NODE_NAME_ADDITIONAL_GUEST_INFO_GROUP = 'additional-guest[0]information';
export const NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME = 'additional-guest[0]first-name';
export const NODE_NAME_ADDITIONAL_GUEST_LAST_NAME = 'additional-guest[0]last-name';
export const NODE_NAME_ADDITIONAL_GUEST_EMAIL = 'additional-guest[0]email';
export const NODE_NAME_ADDITIONAL_GUEST_TEMPLATE = 'additional-guest-template';
export const NODE_NAME_UTM_PARAMS = 'utm';
export const NODE_NAME_UTM_SOURCE = 'utm[source]';
export const NODE_NAME_UTM_MEDIUM = 'utm[medium]';
export const NODE_NAME_UTM_CAMPAIGN = 'utm[campaign]';
export const NODE_NAME_UTM_TERM = 'utm[term]';
export const NODE_NAME_UTM_CONTENT = 'utm[content]';
export const NODE_NAME_CHECK_IN = 'check-in';
export const NODE_NAME_CHECK_OUT = 'check-out';
export const NODE_NAME_CAPTCHA = 'captcha';
export const NODE_NAME_CC_EMAIL = 'cc-email';
export const NODE_NAME_BCC_EMAIL = 'bcc-email';
export const NODE_NAME_SOCIAL_RSVP = 'social-rsvp';
export const NODE_NAME_DATE_RANGE = 'date-range-template';
export const NODE_NAME_DATE_RANGE_START_DATE = 'date-range-start-date';
export const NODE_NAME_DATE_RANGE_END_DATE = 'date-range-end-date';
export const NODE_NAME_DATE_RANGE_START_TIME = 'date-range-start-time';
export const NODE_NAME_DATE_RANGE_END_TIME = 'date-range-end-time';

export const NODE_NAME_ADDITIONAL_GUEST_PREFIX_REGEXP = /^(additional-guest)\[([0-9]+)\](.*)$/;
export const NODE_NAME_ADDITIONAL_GUEST_INFO_GROUP_REGEXP = /^additional-guest\[([0-9]+)\]information$/;
export const NODE_NAME_ADDITIONAL_GUEST_FN_REGEXP = /^(additional-guest)\[([0-9]+)\]first-name$/;
export const NODE_NAME_ADDITIONAL_GUEST_LN_REGEXP = /^(additional-guest)\[([0-9]+)\]last-name$/;
export const NODE_NAME_ADDITIONAL_GUEST_EMAIL_REGEXP = /^(additional-guest)\[([0-9]+)\]email$/;

export const NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME_PATTERN = 'additional-guest[{{n}}]first-name';
export const NODE_NAME_ADDITIONAL_GUEST_LAST_NAME_PATTERN = 'additional-guest[{{n}}]last-name';
export const NODE_NAME_ADDITIONAL_GUEST_EMAIL_PATTERN = 'additional-guest[{{n}}]email';
